const $body = document.body;

const init = (instance) => {
    instance.$close.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        instance.hide();
    });

    instance.$el.addEventListener('click', (event) => {
        event.stopPropagation();
    });

    [...instance.$vgtrkBarDrops].forEach($button => {
        $button.addEventListener('click', (event) => {
            event.preventDefault();

            let $list = $button.nextElementSibling;

            if ($list.classList.contains('active')) {
                $list.classList.remove('active');
                $button.classList.remove('active');
            } else {
                $list.classList.add('active');
                $button.classList.add('active');
            }

        })
    });

    document.addEventListener('click', (event) => {
        if (instance.isActive) {
            instance.hide();
        }
    });
};

export default class Navigation {
    constructor() {
        this.$el      = document.querySelector('.navigation');
        this.$close   = this.$el.querySelector('.navigation__close');
        this.isActive = this.$el.classList.contains('navigator--active');

        this.$vgtrkBarDrops = this.$el.querySelectorAll('.root.dropdown a.root, .navigator__link--drop-down');

        init(this);
    }

    toggle() {
        return this.isActive ? this.hide() : this.show();
    }

    show() {
        $body.classList.add('app--active-navigation');
        this.isActive = true;
    }

    hide() {
        $body.classList.remove('app--active-navigation');
        this.isActive = false;
    }

}